//#region Dependencies
import { CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  GridContainer,
  GridItem,
  GridItemIcon,
  GridItemText,
  GridItemTitle,
  GridItemViewMore,
} from "./styles";
//#endregion

import {
  Person as PersonIcon,
  Apps as AppsIcon,
  Apartment as ApartmentIcon,
} from "@mui/icons-material";
import Loading from "../../Components/Loading";
import { useNavigate } from "react-router-dom";
import { UserPermissions } from "../../App";

const gridItemSize = 3;
interface Props {
  userPermissions: UserPermissions;
}
const Main: React.FC<Props> = ({ userPermissions }) => {
  const navigate = useNavigate();

  const [statistics, setStatistics] = useState({
    users: -1, //Integer
    patients: -1, //Integer
    softwares: -1, //Integer
    organizations: -1, //Integer
    cpu: -1, //0 -> 1 (Percentage / 100 but rounded to 3)
    ram: -1, //0 -> 1 (Percentage / 100 but rounded to 3)
    storage: -1, //0 -> 1 (Percentage / 100 but rounded to 3)
    network: -1, //Integer
  });

  useEffect(() => {
    console.log("User permissions:", userPermissions);
    const interval = setInterval(() => {
      fetch(`/api/v1/statistics`)
        .then((response) => response.json())
        .then((data) => {
          if (data.success === true) {
            delete data.success;
            setStatistics(data);
          }
        })
        .catch((err) => {
          console.log("Cannot fetch data from the API: ", err);
        });
    }, 1500);
    return () => {
      clearInterval(interval);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // /api/v1/statistics

  return (
    <GridContainer
      container
      sx={{ flexDirection: { xs: "column", md: "row" } }}
      justifyContent="center"
    >
      {userPermissions.ORI.Admin && (
        <GridItem item xs={gridItemSize}>
          <GridItemTitle>Users</GridItemTitle>
          <GridItemText>{statistics.users === -1 ? <CircularProgress /> : statistics.users}</GridItemText>
          <GridItemViewMore
            onClick={() => {
              navigate(process.env.PUBLIC_URL + "/Users");
            }}
          >
            View all users
          </GridItemViewMore>
          <GridItemIcon style={{ backgroundColor: "rgba(219, 57, 52, 0.5)" }}>
            <PersonIcon />
          </GridItemIcon>
        </GridItem>
      )}

      {(userPermissions.ORI.Admin ||
        userPermissions.ORI.Researcher ||
        userPermissions.OrgDeveloper.length > 0) && (
          <GridItem item xs={gridItemSize}>
            <GridItemTitle>Softwares</GridItemTitle>
            <GridItemText>{statistics.softwares === -1 ? <CircularProgress /> : statistics.softwares}</GridItemText>
            <GridItemViewMore
              onClick={() => {
                navigate(process.env.PUBLIC_URL + "/Softwares");
              }}
            >
              View all softwares
            </GridItemViewMore>
            <GridItemIcon style={{ backgroundColor: "rgba(250, 166, 19, 0.5)" }}>
              <AppsIcon />
            </GridItemIcon>
          </GridItem>
        )}

      {userPermissions.ORI.Admin && (
        <GridItem item xs={gridItemSize}>
          <GridItemTitle>Organizations</GridItemTitle>
          <GridItemText>{statistics.organizations === -1 ? <CircularProgress /> : statistics.organizations}</GridItemText>
          <GridItemViewMore
            onClick={() => {
              navigate(process.env.PUBLIC_URL + "/Organizations");
            }}
          >
            View all organizations
          </GridItemViewMore>
          <GridItemIcon style={{ backgroundColor: "rgba(0, 144, 193, 0.5)" }}>
            <ApartmentIcon />
          </GridItemIcon>
        </GridItem>
      )}
      {(userPermissions.OrgClinical.length > 0 ||
        userPermissions.ORI.Researcher) && (
          <GridItem item xs={gridItemSize*3}>
            <GridItemTitle>Patients</GridItemTitle>
          <GridItemText>{statistics.patients === -1 ? <CircularProgress /> : statistics.patients}</GridItemText>
            <GridItemViewMore
              onClick={() => {
                navigate(process.env.PUBLIC_URL + "/Patients");
              }}
            >
              View all patients
            </GridItemViewMore>
          </GridItem>
        )}

      {userPermissions.ORI.Admin && (
        <GridItem item xs={gridItemSize}>
          <GridItemTitle>CPU</GridItemTitle>
          {statistics.cpu === -1 ? <CircularProgress size="7rem" sx={{position: "relative", left: "35%"}} /> :
            <Loading percentage={statistics.cpu} size="7rem" />
          }
        </GridItem>
      )}

      {userPermissions.ORI.Admin && (
        <GridItem item xs={gridItemSize}>
          <GridItemTitle>RAM</GridItemTitle>
          {statistics.ram === -1 ? <CircularProgress size="7rem" sx={{position: "relative", left: "35%"}} /> :
            <Loading percentage={statistics.ram} size="7rem" />
          }
        </GridItem>
      )}

      {userPermissions.ORI.Admin && (
        <GridItem item xs={gridItemSize}>
          <GridItemTitle>Storage</GridItemTitle>
          {statistics.storage === -1 ? <CircularProgress size="7rem" sx={{position: "relative", left: "35%"}} /> :
            <Loading percentage={statistics.storage} size="7rem" />
          }
        </GridItem>
      )}

      {/** userPermissions.ORI.Admin  && (
        <GridItem item xs={gridItemSize}>
          <GridItemTitle>Network</GridItemTitle>
          <GridItemText>{statistics.network} Mb/s</GridItemText>
        </GridItem>
      ) **/}

    </GridContainer>
  );
};

export default Main;
